import styled from "styled-components";

import locationIcon from "../../../../assets/Mayo/Location.svg";

export default function MayoVisitInfo({procedureText, procedureDate, address1, address2}) {
  return (
    <Container>
      <ProcedureDateText>
        {procedureText} {procedureDate}
      </ProcedureDateText>


      <LocationWrapper>
        <LocationIcon
          src={locationIcon}
          width={"28px"}
          height={"41px"}
        />
        <LocationTextWrapper>
          <Address>{address1}</Address>
          <Address>{address2}</Address>
        </LocationTextWrapper>
      </LocationWrapper>
    </Container>
  );
}

const Container = styled.div`
`

const ProcedureDateText = styled.p`
  margin-block: 24px;
  margin-left: 26px;
  margin-right: 25px;
  font-size: 22px;
  font-weight: bold;
  text-align: left;
`


const LocationWrapper = styled.div`
  margin-left: 26px;
  margin-right: 15px;
  margin-bottom: 43px;
  display: flex;
  align-items: center;
  gap: 12px;
`

const LocationTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`


const LocationIcon = styled.img`
  
`

const Address = styled.p`
  font-size: 19px;
  text-align: left;
  font-weight: 400;
  margin: 0;
`
